/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {GroupFormComponent as ɵc} from './group-form/group-form.component';
export {GroupComponent as ɵb} from './group.component';
export {declaration as ɵa} from './group.module';
export {GroupRoutes as ɵd} from './group.routing';